import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';

const groups = [
  {
    title: 'งานและปฏิทิน',
    items: [
      { to: '/delegate-calendar', label: 'ลงนัดให้ผู้อื่น', detail: 'สร้างนัดในปฏิทินที่ได้รับมอบหมาย', icon: '＋' },
      {
        to: '/appointments',
        label: 'รายการทั้งหมด',
        detail: 'ดูและแก้ไขนัดหมายหรือกิจกรรม',
        icon: '▣',
      },
      {
        to: '/calendar/import',
        label: 'กล่องนำเข้า',
        detail: 'ตรวจรายการจาก Google Calendar',
        icon: '⇩',
      },
      { to: '/meetings', label: 'การประชุม', detail: 'หมวดเรื่องประชุมและรายงาน', icon: '⌘' },
    ],
  },
  {
    title: 'เอกสาร',
    items: [
      { to: '/documents', label: 'คลังเอกสาร', detail: 'จัดเก็บและจัดหมวดหมู่ไฟล์', icon: '▤' },
      {
        to: '/document-search',
        label: 'ค้นหา',
        detail: 'ค้นคลังเอกสารและการประชุม',
        icon: '⌕',
      },
    ],
  },
  {
    title: 'ระบบ',
    items: [
      {
        to: '/settings',
        label: 'ตั้งค่า',
        detail: 'จัดการหมวดหมู่ ป้ายกำกับ และการเชื่อมต่อ',
        icon: '⚙',
      },
    ],
  },
];

export function MorePage() {
  return (
    <Layout title="เพิ่มเติม">
      <div className="space-y-6">
        <div>
          <p className="workspace-eyebrow">เครื่องมือทั้งหมด</p>
          <h2 className="text-2xl font-bold text-[#edf7ff]">เลือกสิ่งที่ต้องการทำ</h2>
          <p className="mt-1 text-sm text-[#b9d1e5]">
            งานหลักอยู่ที่แถบด้านล่าง ส่วนเครื่องมืออื่นรวมไว้ที่นี่
          </p>
        </div>
        {groups.map((group) => (
          <section key={group.title} aria-label={group.title}>
            <h3 className="mb-3 text-sm font-semibold text-[#a6dfff]">{group.title}</h3>
            <div className="grid gap-3 sm:grid-cols-2">
              {group.items.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="card flex items-center gap-4 transition hover:-translate-y-0.5 hover:shadow-lg"
                >
                  <span
                    className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#254766] text-2xl text-[#8bd8ff]"
                    aria-hidden
                  >
                    {item.icon}
                  </span>
                  <span>
                    <span className="block font-semibold">{item.label}</span>
                    <span className="block text-sm text-[#adc9dd]">{item.detail}</span>
                  </span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Layout>
  );
}
